import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  alert: ({ vertical }) =>
    vertical === 'top' && {
      top: theme.spacing(9),
    },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Alert/useStyles.js